import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Building2, MapPin, Globe, Briefcase } from 'lucide-react';
import { getEmployers } from '../services/api';

export default function Employers() {
  const [employers, setEmployers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getEmployers().then(res => { setEmployers(res.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <>
      <div className="page-header">
        <h1>Our Employers</h1>
        <p>We work with top companies across India to bring you the best opportunities</p>
        <div className="breadcrumb">
          <Link to="/">Home</Link> / <span>Our Employers</span>
        </div>
      </div>
      <div className="section">
        <div className="container">
          <div className="section-header">
            <div className="badge">We Are Hiring</div>
            <h2>Companies That Trust Us</h2>
            <p>Partnered with 500+ organizations across Delhi NCR and beyond</p>
          </div>
          {loading ? (
            <div className="loading"><div className="spinner"></div></div>
          ) : (
            <div className="categories-grid">
              {employers.map(emp => (
                <div className="value-card" key={emp.id}>
                  <div className="value-icon"><Building2 size={24} /></div>
                  <h3>{emp.name}</h3>
                  {emp.industry && <div style={{ display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'center', fontSize: '0.813rem', color: '#64748b', marginBottom: 4 }}><Briefcase size={14} /> {emp.industry}</div>}
                  {emp.location && <div style={{ display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'center', fontSize: '0.813rem', color: '#94a3b8' }}><MapPin size={14} /> {emp.location}</div>}
                  {emp.website && <a href={emp.website} target="_blank" rel="noreferrer" style={{ display: 'flex', alignItems: 'center', gap: 6, justifyContent: 'center', fontSize: '0.813rem', color: '#2563eb', marginTop: 8 }}><Globe size={14} /> Visit Website</a>}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
